import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import TierIcon from '@wix/da-ds/pkg/Icons/24x24/Tier';
import CheckIcon from '@wix/da-ds/pkg/Icons/24x24/Check';
import CloseIcon from '@wix/da-ds/pkg/Icons/24x24/Close';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { ResourceType } from '../../types/resource';
const ProfileOwnerSubscribeButton = ({ user, className })=>{
    const { t } = useTranslation();
    const [isMouseOver, setIsMouseOver] = useState(false);
    const handleMouseLeave = useCallback((e)=>{
        // when you click on button's child elements,
        // the mouseleave event triggers
        if (e.currentTarget !== e.target) {
            return;
        }
        setIsMouseOver(false);
    }, []);
    const handleMouseEnter = useCallback(()=>{
        setIsMouseOver(true);
    }, []);
    return /*#__PURE__*/ React.createElement(SolidButton, {
        size: "large",
        variant: "main",
        className: className,
        onMouseLeave: handleMouseLeave,
        onMouseEnter: handleMouseEnter,
        priority: user.isSubscribed ? 'secondary' : 'primary',
        icon: user.isSubscribed ? isMouseOver ? CloseIcon : CheckIcon : TierIcon,
        href: Url.userLink(user.username, `${USER_PROFILE_SECTION_PATHS.SUBSCRIPTIONS}#nav`),
        biData: BiData({
            evid: 547,
            typeid: ResourceType.USER,
            itemid: user.userId,
            referral_info: ReferralType.PROFILE_SUBNAV,
            sectionname: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue
        })
    }, t(user.isSubscribed ? 'deviation.tier.subscribed' : 'deviation.tier.subscribe'));
};
ProfileOwnerSubscribeButton.displayName = 'ProfileOwnerSubscribeButton';
export default ProfileOwnerSubscribeButton;
